// sagas/dataSaga.js
import { call, put, select, takeLatest } from "redux-saga/effects";
import { fetchApi } from "../../utils/apiUtils";
import { fetchDataFailure, fetchDataSuccess } from "../actions/actions";

// API call
// function fetchPaginatedApi(page) {
//   return 
// }
// Selector to get date range from Redux store
const selectDateRange = (state) => state.dateTime.dateRange;
const selectedCustomer = (state) => state.partner.selectedCustomerId;

const fetchPaginatedApi = async (page, startDate, endDate, customerId) => {

    const response = await fetchApi(`dashboard-partner-customer-list/?page=${page}`,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: {
                "from_date": startDate,
                "to_date": endDate,
                ...(customerId !== '' && { customer: customerId })
            },
            requiresAuth: true
        }

    )
    return await response;
}
// Worker saga
function* fetchPaginatedData(action) {
    try {
        const { startDate, endDate } = yield select(selectDateRange);
        const customerId = yield select(selectedCustomer);
        const response = yield call(fetchPaginatedApi, action.page, startDate, endDate, customerId);

        yield put(fetchDataSuccess(response));
    } catch (error) {
        yield put(fetchDataFailure(error.message || "Error loading data"));
    }
}

// Watcher saga
export function* watchPaginatedData() {
    yield takeLatest("FETCH_DATA_REQUEST", fetchPaginatedData);
}
